import { styled } from "@mui/material/styles";
export const underlineDoubleStyle = {
    textDecorationLine: "underline",
    textDecorationStyle: "double",
    WebkitTextDecorationLine: "underline",
    WebkitTextDecorationStyle: "double",
    MozTextDecorationLine: "underline",
    MozTextDecorationStyle: "double",
};
export const UnderlineDouble = styled("span")({
    textDecorationLine: "underline",
    textDecorationStyle: "double",
});
//# sourceMappingURL=UnderlineDouble.js.map